import {BaseUserViewModel} from './userFriend.viewModel';

export class ReferralViewModel {
    id?: number;
    user?: BaseUserViewModel;
    referral?: BaseUserViewModel;
    created_at?: string;
}

export class UpdatedReferralNameViewModel {
    referral_name?: string;
}

export class ReferralsStatisticViewModel {
    singups?: number = 0;
    paid_singups?: number = 0;
    wallet_amount?: number = 0;
    paid_wallet_amount?: number = 0;
}

export class IsCurrentUserReferralViewModel {
    is_user_referral?: boolean;
    referral_plan_discounts?: boolean;
}
